<div class="container-fluid d-flex flex-column h-100 px-0 ">
    <div class="row h-100 m-0 pb-2 pt-2 pt-sm-4 pb-md-3 mt-md-2 pt-lg-3 pb-lg-0">
        <div class="col-12 d-flex flex-column h-100 px-3 px-md-0 pb-sm-1">
            <div class="d-flex flex-column mt-3 mt-md-1 ">
                <div class="row m-0 pt-2 border-light-grey pb-1 align-items-center pt-md-3 pt-lg-1">
                    <app-search-input class="col-12 col-sm-3 my-1"
                        [searchValue]="displayBoardRegistrationRequestModel.searchText"
                        (changeSearchTextValue)="displayBoardRegistrationRequestModel.searchText=$event; searchFilter()">
                    </app-search-input>

                    <app-dropdown class="col col-sm-3 my-1" 
                    [options]="getAllDropdown.dateRangeDropdown"
                    [dropdownLabel]="'Date Range'" 
                    [id]="'dateRange'" 
                    (dropdownValueEmit)="range($event)"
                    [selectedId]="isCustomRange">
                    </app-dropdown>

                    <ng-container *ngIf="this.isCustomRange == this.dateRangeTypes.CustomRange">
                        <app-range-date-picker class="col-12 col-md-3  my-1"
                            (selectedDates)="selectedRangeDates($event)"
                            (selectedDatesClear)="selectedRangeDatesClear()" 
                            [selectedId]="isCustomRange">
                        </app-range-date-picker>
                    </ng-container>

                    <div class="col-auto col-sm-auto ms-sm-auto d-flex align-items-center justify-content-end gap-2 ps-2 py-2 flex-nowrap">
                        <div class="mx-1 d-flex cursor-pointer"
                            (click)="displayBoardRegistrationRequestModel.fromDate='';displayBoardRegistrationRequestModel.toDate='';displayBoardRegistrationRequestModel.searchText='';isCustomRange = null;searchFilter()">
                            <app-svg-icon name="refresh" [width]="'25px'" [height]="'25px'" ngbTooltip="Reset All Filters"></app-svg-icon>                    
                        </div>
                    </div>
                </div>
            </div>
            <app-ag-grid id="registrationList" class="d-flex flex-column h-100"
                [dataModel]="agGridDataModelDisplayBoardResistrationList"
                [rowData]="rowData"
                [totalRecords]="totalRecords" 
                (gridReady)="onGridReady($event)" 
                [rowHeight]="40"
                (onPageSizeUpdated)="onChnagePage($event)"
                (onPageSizeChanged)="displayBoardRegistrationRequestModel.pageSize =$event;getAllRegistrationList()"
                [pageSize]="displayBoardRegistrationRequestModel.pageSize"
                [page]="displayBoardRegistrationRequestModel.pageNumber"
                (onDeleteIconClick)="deleteDisplayBoardResistration($event)"
                (onCheckBoxClick)="ActiveInactiveDisplayBoard($event)"
                (changeSearchText)="displayBoardRegistrationRequestModel.searchText=$event;searchFilter();">
            </app-ag-grid>
        </div>
    </div>
</div>





